import { defineStore } from 'pinia'
import { isEmpty, parseURL, urlWrapper, urlParams } from '@/utils'
import { HUICE_DEFAULT_URL, getProductId } from '@/constant'

export interface UrlState {
  productID: string,
  redirectUrl: string,
  params: Record<string, string>,
  debug: boolean
}

export const useUrlStore = defineStore({
  id: 'url',
  state: (): UrlState => ({
    productID: '',
    redirectUrl: '',
		params: {},
    debug: false,
  }),
  actions: {
    //初始化
    init() {
		// TODO 
        //获取通过URL传递的用户信息（产品线ID、产品线回调redirectURL）,当前处理非法url,会直接切换到hyj，不太合理，等待3.0版本确定更新
        this.redirectUrl = urlWrapper(
            parseURL(window.location.href, 'redirect', HUICE_DEFAULT_URL)
        )!

        // 计算src
        if (!location.search) {
            const hash = location.href as string
            const qs = urlParams(hash);
            for(const key of Object.keys(qs)) {
                if(qs[key]) {
                    this.params[key] = qs[key]!.toString();
                }
            }
        } else {
            const urlParma = new URL(window.location.href)
            urlParma.searchParams.forEach((value, key) => {
                this.params[key] = value;
            });
        }

        if(this.params['src']) {
            sessionStorage.setItem('src', this.params['src'])
        } else {
            this.params['src'] = sessionStorage.getItem('src') || ''
        }

        //urlData['subSrc'] && sessionStorage.setItem('subSrc', urlData['subSrc'])
        this.productID = this.params['productID']
        if(!this.productID) {
            this.productID = sessionStorage.getItem('prd') || ''
        }
        this.debug = !this.params['debug']

        if (isEmpty(this.productID) && document.referrer) {
            let url = new URL(document.referrer)
            if (!isEmpty(url.origin) && getProductId(url.origin)) {
                this.productID = getProductId(url.origin)
            } else {
                this.productID = ''
            }
        }

        if(this.productID) {
            if(this.productID == 'hjy'){
                localStorage.setItem('loginTab', 'account');
            }
            sessionStorage.setItem('prd', this.productID)
        }
    },
    
	clear() {
		this.params = {};
	}
  },
})
